import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  eventNameList: string[];
}

export const PaymentBenefitCardNameList: React.FC<React.PropsWithChildren<Props>> = ({ eventNameList }) => {
  return (
    <List>
      {eventNameList.map((name, index) => {
        const isLast = index === eventNameList.length - 1;
        const displayDot = !isLast;
        const frontParentheses = index === 0 ? '(' : '';
        const backParentheses = isLast ? ')' : '';

        return (
          <React.Fragment key={index}>
            <Item>
              {frontParentheses}
              {name}
              {backParentheses}
            </Item>
            {displayDot && <Dot>∙</Dot>}
          </React.Fragment>
        );
      })}
    </List>
  );
};

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-weight: 400;
  color: ${vars.color.textStrong};
`;

const Item = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${vars.color.textStrong};
`;

const Dot = styled.div`
  margin: 0 1px;
  color: ${vars.color.textStrong};
`;
